// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: true,
  production: true,
  globals: {

     // Stage
      url: 'https://apis.togoanvt.net/public',
      urlApi: 'https://apis.togoanvt.net/public/api',

      candidat: 'candidat',
      structure: 'structure',
      admin: 'admin'
  },
  otpControl: {
	// Délais en secondes après chaque envoi : [1er, 2ème, 3ème, 4ème, 5ème et +]
      cooldowns: [60, 60, 3600, 10800, 18000]
  },
  youtube: {
        apiKey:'AIzaSyDIoAs8FhtkmzDxWu7zvA58O7RRvUeVtHU',
        playlistId:'https://www.youtube.com/playlist?list=PLRhhQyxePkYs'
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
